import React, { Children, ReactNode } from "react";
import { Checkbox, BoxProps } from "@mui/material";
import { CheckProps } from "./CheckBoxProps";
const CheckBox = (props: CheckProps) => {
  return <Checkbox {...props} />;
};

export default CheckBox;
